import { render, staticRenderFns } from "./CustomerOrSupplier.vue?vue&type=template&id=fec6a8d8&scoped=true"
import script from "./CustomerOrSupplier.vue?vue&type=script&lang=js"
export * from "./CustomerOrSupplier.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrSupplier.vue?vue&type=style&index=0&id=fec6a8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec6a8d8",
  null
  
)

export default component.exports